import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPA = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M0 25c0 13.807 11.193 25 25 25V25H0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0c13.807 0 25 11.193 25 25H25V0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "m14.882 8.696 1.619 4.982h5.238l-4.238 3.079 1.619 4.982-4.238-3.079-4.238 3.08 1.618-4.983-4.238-3.08h5.239l1.619-4.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m35.12 28.262 1.618 4.982h5.239l-4.239 3.079 1.62 4.982-4.239-3.079-4.238 3.08 1.619-4.983-4.238-3.08H33.5l1.62-4.981Z"
}));
FlagPA.displayName = 'FlagPA';
export default withFlagWrapper(FlagPA);
//# sourceMappingURL=index.js.map